import React, { useState } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';

const numberVariants = {
  hidden: { opacity: 0, y: -50 },
  moveIn: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: 'easeOut', type: 'spring', stiffness: 120 },
  },
  moveOut: {
    opacity: 0,
    y: -30,
    transition: { duration: 0.4, ease: 'easeInOut' },
  },
};

const contentVariants = {
  hidden: { opacity: 0, y: 20 },
  moveIn: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: 'easeOut', type: 'spring', stiffness: 100 },
  },
  moveOut: {
    opacity: 0,
    y: 1000,
    transition: { duration: 0.4, ease: 'easeInOut' },
  },
};

function BusinessOutcomes({items}) {
  const [index, setIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: isMobile ? 'center' : 'flex-start',
        justifyContent: 'center',
        gap: 2,
        bgcolor: 'transparent',
      }}
    >
      {items?.map((item, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0.5 }}
          animate={{ opacity: 1 }}
          whileHover={{ scale: 1.02, opacity: 1 }}
          transition={{ duration: 0.3 }}
          onClick={() => setIndex(i)}
          onMouseEnter={() => setIndex(i)}
          style={{
            width: isMobile ? '100%' : index === i ? '660px' : '250px', // Full width on mobile
            height: '370px', // Original height maintained
            flexShrink: 0,
            borderRadius: '12px',
            position: 'relative',
            overflow: 'hidden',
            transition: 'width 0.5s ease-in-out',
            cursor: 'pointer',
            background:
              'radial-gradient(90.16% 143.01% at 15.32% 21.04%, rgba(165, 239, 255, 0.2) 0%, rgba(110, 191, 244, 0.0447917) 77.08%, rgba(70, 144, 213, 0) 100%)',
          }}
        >
          <AnimatePresence mode="wait">
            {index !== i ? (
              <motion.div
                key="number-title"
                variants={numberVariants}
                initial="hidden"
                animate="moveIn"
                exit="moveOut"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  color: '#fff',
                  padding: '16px',
                }}
              >
                <Typography variant="h1" sx={{ fontSize: '100px', fontWeight: 'bold' }}>
                  {item.number}
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ fontSize: '32px', fontWeight: 'medium', textAlign: 'center', px: 1 }}
                >
                  {item.title}
                </Typography>
              </motion.div>
            ) : (
              <motion.div
                key="content"
                variants={contentVariants}
                initial="hidden"
                animate="moveIn"
                exit="moveOut"
                style={{
                  width: '100%',
                  height: '100%',
                  position: 'relative',
                  display: 'flex',
                  flexDirection: isMobile ? 'column' : 'row', // Column on mobile, row on desktop
                  padding: 12,
                  borderRadius: '28px',
                  gap: 4,
                }}
              >
                <Box
                  sx={{
                    width: isMobile ? '100%' : '50%', // Full width on mobile
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    padding: '16px',
                    color: '#fff',
                  }}
                >
                  <Typography sx={{ fontWeight: 600, fontSize: '24px' }}>{item.title}</Typography>
                  <Typography sx={{ lineHeight: '24px', fontSize: '18px', marginBottom: 2 }}>
                    {item.description}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: isMobile ? '100%' : '50%', // Full width on mobile
                    height: isMobile ? '170px' : '100%', // Adjusted height for mobile
                  }}
                >
                  <motion.img
                    src={item.image}
                    alt={item.title}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: '20px',
                      margin: '0 auto',
                    }}
                  />
                </Box>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      ))}
    </Box>
  );
}

export default BusinessOutcomes;